<template>
  <section class="productReleases">
    <div class="product">
      <h1 class="product__title">Lançamentos</h1>
      <div class="product__item">
        <a-skeleton :loading="loading" active> </a-skeleton>
        <div class="product__list" v-for="(info, index) in infos" :key="index">
          <a href="">
            <img
              loading="lazy"
              class="product__image"
              v-lazy="info.ImagemItem"
              :alt="info.Ds_Item"
            />
          </a>
          <p class="product__name">
            {{ info.Ds_Item }}
          </p>
          <div class="product__price">
            <span class="product__pricePer" v-if="info.estoque >= 1">
              {{ (info.vl_liquido_produto * 0.95) | toCurrency }}
              <span class="product__AtSight">à vista</span></span
            >
            <span class="product__priceTerm">
              ou <span> {{ info.vl_liquido_produto | toCurrency }}</span>
            </span>
            <span
              class="product__plots"
              v-if="
                info.vl_liquido_produto >= 195 && info.vl_liquido_produto < 220
              "
            >
              8x de
              {{ (info.vl_liquido_produto / 8) | toCurrency }}
              sem juros</span
            >
            <span
              class="product__plots"
              v-if="
                info.vl_liquido_produto >= 175 && info.vl_liquido_produto <= 194
              "
            >
              7x de
              {{ (info.vl_liquido_produto / 7) | toCurrency }}
              sem juros</span
            >
            <span
              class="product__plots"
              v-if="
                info.vl_liquido_produto >= 155 && info.vl_liquido_produto <= 174
              "
            >
              6x de
              {{ (info.vl_liquido_produto / 6) | toCurrency }}
              sem juros</span
            >
            <span
              class="product__plots"
              v-if="
                info.vl_liquido_produto >= 120 && info.vl_liquido_produto <= 173
              "
            >
              5x de
              {{ (info.vl_liquido_produto / 5) | toCurrency }}
              sem juros</span
            >
            <span
              class="product__plots"
              v-if="
                info.vl_liquido_produto >= 100 && info.vl_liquido_produto <= 119
              "
            >
              4x de
              {{ (info.vl_liquido_produto / 4) | toCurrency }}
              sem juros</span
            >
            <span
              class="product__plots"
              v-if="
                info.vl_liquido_produto >= 80 && info.vl_liquido_produto <= 99
              "
            >
              3x de
              {{ (info.vl_liquido_produto / 3) | toCurrency }}
              sem juros</span
            >
            <span class="product__plots" v-if="info.vl_liquido_produto <= 79">
              2x de
              {{ (info.vl_liquido_produto / 2) | toCurrency }}
              sem juros</span
            >
            <span class="product__plots" v-if="info.vl_liquido_produto > 221">
              10x de
              {{ (info.vl_liquido_produto / 10) | toCurrency }}
              sem juros</span
            >
            <span class="product__lowerQuantity" v-if="info._Disponivel <= 5"
              >Poucas Unidades</span
            >
          </div>
          <div class="product__buttons">
            <button
              class="product__buttons--details"
              @click="productDetails(info.SKU, info.vl_liquido_produto)"
            >
              <i class="fa fa-eye" aria-hidden="true"></i> Detalhes
            </button>

            <button class="product__buttons--buy" @click="addMiniCart(info)">
              <i class="fa fa-shopping-cart" aria-hidden="true"></i> + Carrinho
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import axios from "axios";

export default {
  data() {
    return {
      infos: null,
      loading: false,
      token: null,
    };
  },
  methods: {
    productDetails(sku, preco) {
      localStorage.setItem(
        "precoDetails",
        JSON.stringify({ preco: preco, sku: sku })
      );
      window.location.href = `details?sku=${sku}`;
    },
    addMiniCart(produto) {
      let totalItens = 0;

      let carrinho =
        localStorage.getItem("carrinho") != "" ||
        localStorage.getItem("carrinho") == null ||
        localStorage.getItem("carrinho") == undefined
          ? JSON.parse(localStorage.getItem("carrinho"))
          : [];
      let productAdd = {
        sku: produto.SKU,
        nomeItem: produto.Ds_Item,
        imagem: produto.ImagemItem,
        quantidade: 1,
        marca: produto.Marca,
        valor: produto.vl_liquido_produto,
        estoque: produto.estoque,
      };

      if (carrinho.length > 0) {
        let validarItem = carrinho.find((x) => x.sku == productAdd.sku);
        if (validarItem != undefined && validarItem != null) {
          carrinho.forEach(function (e) {
            if (e.sku == productAdd.sku) {
              e.quantidade = e.quantidade + 1;
            }
          });
        } else {
          carrinho.push(productAdd);
        }
      } else {
        carrinho.push(productAdd);
      }
      carrinho.forEach(function (e) {
        totalItens = parseFloat(totalItens) + parseFloat(e.quantidade);
      });
      localStorage.setItem("carrinho", JSON.stringify(carrinho));
      document.getElementsByClassName(
        "header__quantity"
      )[0].innerText = totalItens;
      document.getElementsByClassName("header__cart")[0].click();
    },
    async getDados() {
      try {
        let dados = JSON.parse(localStorage.getItem("login"));

        if (dados != undefined) {
          this.token = dados.token;
        } else {
          this.token = "";
        }

        try {
          this.loading = true;
          const response = await axios.get(
            `https://www.leverosintegra.com.br/MAP/api/ProdutoLista?tipo=lancamentos&token=${this.token}`
          );
          this.infos = response.data.lcardapio;
          this.loading = false;
        } catch (e) {
          this.errors.push(e);
          this.loading = false;
        }

      } catch (e) {
        console.log(e);
      }
    },
  },
  beforeMount() {
    this.getDados();
  },
};
</script>

<style lang="scss" scoped>
.productReleases {
  display: flex;
  margin: 0 auto;
  padding-top: 40px;
  flex-direction: column;
  max-width: 100%;

  @media (min-width: 769px) {
    max-width: 90%;
    flex-direction: row;
  }
  @media (min-width: 1920px) {
    max-width: 70%;
  }
}

.product {
  width: 100%;

  &__title {
    color: var(--standardGreen);
    margin: 20px;
  }

  &__item {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    color: var(--customGray-500);
    width: 100%;
    margin-top: 0;
    padding: 0 10px;

    @media (min-width: 769px) {
      width: initial;
      padding: 0;
    }
  }

  &__list {
    margin: 3px;
    border: 1px solid var(--customGray-100);
    border-radius: 5px;
    padding: 25px 0;
    width: 100%;

    @media (min-width: 321px) and (max-width: 768px) {
      width: 48%;
      margin: 3px;
    }

    @media (min-width: 769px) {
      width: 24%;
    }

    &:hover {
      border: 1px solid var(--standardGreen);
      background: linear-gradient(
        10deg,
        rgba(0, 90, 100, 0.2839110644257703) 0%,
        rgba(0, 90, 100, 0.014) 45%
      );
    }
  }

  a {
    display: flex;
    justify-content: center;
  }

  &__image {
    max-width: 220px;
    height: auto;
  }

  &__name {
    text-align: center;
    padding-bottom: 20px;
    font-size: 1rem;
  }

  &__price {
    display: flex;
    flex-direction: column;
    padding-left: 10px;

    @media (min-width: 441px) {
      padding-left: 15px;
    }
  }

  &__pricePer {
    color: var(--standardGreen);
    font: 700 1.3rem "Soleto", sans-serif;
  }

  &__AtSight {
    font-size: 0.85rem;
  }

  &__priceTerm {
    padding: 3px 0;
    font-size: 0.95rem;
  }

  &__plots {
    font-size: 0.95rem;
  }

  &__lower-quantity {
    background-color: #ff000030;
    border-radius: 2px;
    width: 90%;
    margin: 15px 0 0 0;
    padding: 3px 0;
    text-align: center;
    font-size: 0.85rem;
  }

  &__buttons {
    padding-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column-reverse;

    @media (min-width: 1309px) {
      flex-direction: row;
    }

    &--details {
      border: 1px solid var(--customDarkGreen);
      border-radius: 5px;
      color: var(--customDarkGreen);
      font-size: 0.95rem;
      outline: none;
      margin: 10px 3px;
      width: 95%;
      padding: 11px;

      @media (min-width: 1309px) {
        margin: 0 10px;
        padding: 7px;
        width: initial;
      }
    }

    &--buy {
      background-color: var(--standardGreen);
      border-radius: 5px;
      color: var(--customWhite);
      font: 700 0.95rem "Soleto", sans-serif;
      outline: none;
      width: 95%;
      padding: 13px;

      @media (min-width: 1309px) {
        width: initial;
        padding: 7px;
      }
    }
  }
}
</style>